// test2077
(2077 && 0);
